import type { SiteMenuItem } from '@/router/types';
import { type VNode } from 'vue';
import iconUtil from './icon';

const menuUtil = {
  /**
   * @description 渲染 FormItem icon VNode
   */
  renderIcon(icon: string | VNode) {
    if (typeof icon === 'string') {
      return iconUtil.renderIcon(icon, { fontSize: '16px' })();
    }
    return icon;
  },

  /**
   * @description 获取菜单的完整路径
   */
  getMenuFullPath(menus: SiteMenuItem[], key: string) {
    const res: {
      name: string;
      icon: VNode | (() => VNode);
      key: string;
    }[] = [];

    function transfer(input: SiteMenuItem) {
      return { name: input.label, icon: input.icon, key: input.key };
    }

    let flag = false;

    function iter(items: SiteMenuItem[]) {
      if (flag) {
        return;
      }
      for (const item of items) {
        if (item.key === key) {
          flag = true;
          res.push(transfer(item));
          return;
        }
        if (item.children) {
          res.push(transfer(item));
          iter(item.children);
          if (flag) {
            return;
          }
          res.pop();
        }
      }
    }

    iter(menus);
    return res;
  },
};

export default menuUtil;
